import { InputProps } from '@chakra-ui/input';
import theme from '@chakra-ui/theme';

export const Input = {
  parts: ['field', 'addon'],
  baseStyle: {
    field: {
      color: 'white',
      fontSize: 'xs',
      fontWeight: 'bold',
      caretColor: 'currentColor',
      fontFamily: 'body',

      '&&&': {
        boxShadow: 'none',
        border: '2px',
        borderRightRadius: 'base',
        borderColor: 'alpha.100',
        borderLeft: 'none',
        bg: 'alpha.800',
      },

      '&::placeholder': {
        color: 'whiteAlpha.700',
      },

      '&:hover': {
        '&&': {
          bg: 'alpha.500',
          borderLeft: 'none',
          color: 'white',
        },
      },

      '&:focus, &:active': {
        '&&': {
          bg: 'alpha.800',
          borderLeft: 'none',
          borderColor: 'beta.200',
        },
      },

      '&:-webkit-autofill': {
        caretColor: 'currentColor',
        '&:hover, &:focus, &:active': { caretColor: 'currentColor' },
      },
    },
    addon: {
      fontWeight: 'bold',
      fontSize: 'sm',
      fontFamily: 'Roboto',

      '&&': {
        mr: 0,
        bgGradient: 'linear(to-b, alpha.100, alpha.200)',
        color: 'blackAlpha.800',
        textShadow: '0px 1px 0px rgba(255, 255, 255, 0.35)',
        borderLeftRadius: 'base',
        border: 'none',
        _groupFocusWithin: {
          bgGradient: 'linear(to-b, beta.200, beta.400)',
        },
      },
    },
  },
  sizes: {
    lg: { addon: { borderRadius: 'sm' }, field: { borderRadius: 'sm' } },
    md: { addon: { borderRadius: 'sm' }, field: { borderRadius: 'sm' } },
  },
  variants: {
    unstyled: (props: InputProps) => {
      const { addon, field } = theme.components.Input.variants.outline(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        props as any
      );

      return {
        addon,
        field: {
          ...field,
          '&&': {
            boxShadow: 'none',
            color: 'black',
            bg: 'white',
            borderRadius: 'base',
            h: '40px',
            borderColor: 'white',
            pl: '2.5',
          },
          '&:focus, &:active, &:hover': {
            '&&': {
              bg: 'white',
              borderColor: 'white',
              color: 'black',
            },
          },
        },
      };
    },
  },
  defaultProps: {
    size: 'md',
  },
};
